import React, {useEffect, useState} from "react";
import SideBar from "../../Navbars/SideBar";
import NavBar from "../../Navbars/NavBar";
import {
    Dialog,
    Button,
    SearchInput,
} from "evergreen-ui";
import {
    MDBAlert,
    MDBCol, MDBIcon,
    MDBRow,
} from "mdbreact";
import {Card, Layout} from "antd";
import {Text} from "react-font";
import { useList, useListVals } from 'react-firebase-hooks/database';
import Firebase from "../../../Firebase";
import ViewProducts from "../../Modals/Product/ViewProducts";
import { useLocation } from "react-router-dom";
import FireFetch from "../../FireFetch";
import CreateProductModal from "../../Modals/Product/CreateProductModal";
import {useCollection} from "react-firebase-hooks/firestore";


const { Content } = Layout;
const db = Firebase.firestore();
var prodStoreRef = Firebase.storage().ref("System/Products");
const moment = require("moment");

var storageRef = Firebase.storage().ref("System/Products");

const ProductsViewPage = (props) => {


    const [checkedData, setCheckedData] = useState(true);
    const callback = (data) => {
        setCheckedData(data);
    }
    const [products, loading, error] = useCollection(
        db.collection('products'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [showAlert, setShowAlert] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [color, setColor] = useState("info");
    const [message, setMessage] = useState("");
    const [viewModal, setViewModal] = useState(false);
    const [productArray, setProductArray] = useState([]);
    const [dataArray, setDataArray] = useState([]);
    const [stringUrl, setStringUrl] = useState(null);


    useEffect(() => {
        
        if(products){
            var prodArray = [];
            products.docs.map((snapshot) => {
                var product = snapshot.data();
                console.log(product)
                product.productID&&prodStoreRef.child(product.productID).child("image")
                    .getDownloadURL()
                    .then((url) => {
                        product.url = url;
                        setStringUrl(url);
                    });

                prodArray.push(product);

            });

            if(props.location.products !== undefined){
                console.log(props.location.products);

                /*
                //console.log(props.location.products);
                var tempArray = [];
                var valueArray = Object.values(props.location.products);
                valueArray.map((itemID, index) => {
                    var prodObject = {}
                    prodRef.child(itemID.productID).on("value", function (snapshot) {
                        prodObject = snapshot.val();
                        prodStoreRef.child(itemID.productID).child("image")
                            .getDownloadURL()
                            .then((url) => {
                                prodObject.url = url;
                                setStringUrl(url);
                            });
                        tempArray.push(prodObject);
                    });
                })

                setProductArray([...tempArray]);
                setDataArray([...tempArray])

                 */
            }
            setProductArray([...prodArray]);
            setDataArray([...prodArray]);

        }

    }, [props, products])


    const handleSearch = searchText => {
        console.log(productArray);
        const filteredEvents = productArray.filter(({ name, productType, price }) => {
            name = name.toLowerCase();
            productType = productType.toLowerCase();
            price = price.toLowerCase();
            return name.includes(searchText) || productType.includes(searchText) || price.includes(searchText);
        });

        setDataArray(filteredEvents);
    };


    const deleteProduct = (productID) => {
        console.log(productID)

        db.collection("products").doc(productID).delete()
            .then(() => {
                setMessage("Product deleted successfully");
                setColor("success");
                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                }, 3000);

                storageRef.child(productID).listAll()
                    .then((res) => {
                        res.items.forEach((itemRef) => {
                            itemRef.delete().then(() => {
                                console.log("deleted");
                            }).catch(() => {
                            })
                        });
                    }).then(() => {
                }).catch((error) => {
                });
        })
            .catch((error) => {
                setMessage("Unable to delete Product occurred :: " + error.message);
                setColor("danger");
                setShowAlert(true);
        });
    }


    return (

        <>

            <Layout style={{width: "100vw"}}>
                <SideBar checked={checkedData}/>
                <Layout className="site-layout">
                    <NavBar token={"token"} checkBack={callback}/>
                    <Content
                        className="site-layout-background"
                        style={{ margin: '10px 16px 15px'}}
                    >
                        <MDBRow className="w-100">
                            <MDBCol md={12}>

                                <Dialog
                                    isShown={showModal}
                                    title="Create New Product"
                                    onCloseComplete={() => {setShowModal(false)}}
                                    shouldCloseOnOverlayClick={false}
                                    hasFooter={false}>

                                    <MDBCol md={12}>
                                        <CreateProductModal modal={setShowModal}/>
                                    </MDBCol>

                                </Dialog>

                                <Card className="w-100">

                                    <MDBRow>
                                        <MDBCol md={12} className="w-100">
                                            <div className="text-left">
                                                <div className="d-block">
                                                    <h5 className="font-weight-bold">
                                                        <Text family='Nunito'>
                                                            {props.location.outlet ? "Products - " + props.location.outlet.name : "Products"}
                                                        </Text>
                                                    </h5>
                                                </div>
                                            </div>

                                            <MDBRow className="ml-1">
                                                <SearchInput height={40} placeholder="Search products" className="w-100"   onChange={e => handleSearch(e.target.value)} />
                                                <Button height={40} appearance="primary" className="mx-2" onClick={() => {setShowModal(true)}}>
                                                    New Product
                                                </Button>
                                            </MDBRow>
                                        </MDBCol>

                                    </MDBRow>

                                </Card>

                                <Card>
                                    { showAlert ?
                                        <>
                                            <MDBAlert color={color} className="my-3 font-italic" >
                                                {message}
                                            </MDBAlert>
                                        </>
                                        : null }
                                    <ViewProducts products={dataArray} loading={loading} error={error} delete={deleteProduct}/>
                                </Card>

                            </MDBCol>
                        </MDBRow>
                    </Content>
                </Layout>
            </Layout>

        </>
    )

}

export default ProductsViewPage;
